// Node
const $ = require('jquery');


export function popupInit() {

  $('.overlay').on('click', closePopup);
  initPopupListeners();

  $('.room-info').on('click', function (e) {
    if (e.target !== this)
      return;

    let popupEl = $('.overlay, .popup');
    popupEl.trigger('popupClosed');
    popupEl.fadeOut();
    $('html').css('overflow', 'auto');

    // Избавляемся от эффекта горизонтального прыжка
    setMarginsAndPaddings([$('.wrapper'), $('.call.open_popup'), $('.user_info')],
        [$('.page-nav.fix-nav'), $('.popup:not(.popup-auth)')], 0);
  });

  $('.input-popup-down__select').on('click', function () {
    $('.input-popup-down').fadeOut();
  });

  // Закрываем модальное окно по нажатию Escape
  $(document).keyup(function (event) {
    if (event.keyCode === 27) {
        closePopup();
    }
  });

  $('.close-auth-popup').on('click', function (e) {
    if (!$(e.target).closest('.popup-auth__content').length) {
      closePopup();
    }
  });
}

export default function initPopupListeners() {
  $('.open_popup').each(function () {
    this.onclick = (e) => openPopupListener(e)
  });

  $('.popup .popup-close').each(function () {
    this.onclick = (e) => closePopup(e)
  });
}

/**
 * Устанавливает или убирает отступы для элементов,
 * чтобы убрать эффект горизонтального прыжка при открытии/закрытии модальных окон
 *
 * @param {jQuery[]} elements_margin элементы, для которых устанавливается margin
 * @param {jQuery[]} elements_padding элементы, для которых устанавливается padding
 * @param {int} value значение margin/padding
 */
function setMarginsAndPaddings(elements_margin, elements_padding, value) {
  elements_margin.forEach((el) => el.css('margin-right', `${value}px`));
  elements_padding.forEach((el) => el.css('padding-right', `${value}px`));
}

function openPopupListener(event) {
  // Избавляемся от эффекта горизонтального прыжка - рассчитываем размер окна до открытия модалки
  let wrapper = $('.wrapper');
  let width_without_offset = wrapper.innerWidth();

  let popup_id = $('#' + event.currentTarget.attributes.rel.value);
  $(popup_id).fadeIn();
  $('.overlay').fadeIn();
  $('html').css('overflow', 'hidden');

  // Исходя из нового размера рабочего окна получаем разницу - ширину скролла
  let offset_width = wrapper.innerWidth() - width_without_offset;
  if (offset_width) {
    setMarginsAndPaddings([wrapper, $('.call.open_popup'), $('.user_info'), $('.popup .container-fluid')],
        [$('.page-nav.fix-nav'), $('.popup:not(.popup-auth)')], offset_width);
  }
}

function closePopup(event){
  let overlayEl = $('.overlay');
  if(overlayEl.length > 0)
    overlayEl.fadeOut();
  let popupEl = $('.popup');
  if (popupEl.length > 0) {
    popupEl.fadeOut();
    popupEl.trigger('popupClosed');
  }
  $('html').css('overflow', 'auto');

  // Избавляемся от эффекта горизонтального прыжка
  setMarginsAndPaddings([$('.wrapper'), $('.call.open_popup'), $('.user_info')], [$('.page-nav.fix-nav'), popupEl], 0);

  let yvideoEl = document.getElementsByClassName("yvideo");
  if(yvideoEl.length > 0)
    yvideoEl[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

  setTimeout( () => {
    if (popupEl.hasClass('auth-popup')) {
      resetLoginForm();
    }
  }, 500);
}

export function closePopupById(popup_id) {
  let overlayEl = $('.overlay');
  if (overlayEl.length > 0)
    overlayEl.fadeOut();

  let popupEl = $('#' + popup_id);
  if (popupEl.length > 0) {
    popupEl.fadeOut();
    popupEl.trigger('popupClosed');
  }
  $('html').css('overflow', 'auto');

  setMarginsAndPaddings([$('.wrapper'), $('.call.open_popup'), $('.user_info')],
      [$('.page-nav.fix-nav'), $('.popup:not(.popup-auth)')], 0);

  let yvideoEl = document.getElementsByClassName("yvideo");
  if (yvideoEl.length > 0)
    yvideoEl[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
}

export function openPopupById(popupId) {
  const wrapper = $('.wrapper');
  const widthWithoutOffset = wrapper.innerWidth();

  const popup = $('#' + popupId);
  $(popup).fadeIn();
  $('.overlay').fadeIn();
  $('html').css('overflow', 'hidden');

  const offsetWidth = wrapper.innerWidth() - widthWithoutOffset;
  if (offsetWidth) {
    setMarginsAndPaddings(
        [wrapper, $('.call.open_popup'), $('.user_info'), $('.popup .container-fluid')],
        [$('.page-nav.fix-nav'), $('.popup:not(.popup-auth)')],
        offsetWidth
    );
  }
}

export function resetLoginForm() {
  $('#auth-login-form').show();
  $('#auth-register-form').hide();
  $('#auth-register-code-form').hide();
  $('#auth-login-code-form').hide();
  $('[name="auth-login-form-code"]').closest('.sms-code-field').hide();
  $('[name="auth-register-form-code"]').closest('.sms-code-field').hide();
  $('#user-phone-sms').parent().hide();
  $('.sms-code-timer').hide();
  $('#auth-popup a.popup-tabs__tab-active').removeClass('popup-tabs__tab-active');
  $('a[data-target="auth-login-form"]').addClass('popup-tabs__tab-active');
}
